module.exports = __webpack_public_path__ + "img/6_41.06bddf86.png";